import React from 'react';
import { PropTypes } from 'prop-types';
import { NikeI18nProvider } from '@nike/i18n-react';
import useFetchStaticData from '@nike/shop-apis/query-hooks/use-fetch-static-data';
import getWebShellClientLocale from '../../state/redux-replacement/get-webshellclient-locale';

const NikeI18nProviderTranslations = ({ children }) => {
  const { hreflang: language } = getWebShellClientLocale();
  const { data: translations = {}, isSuccess } = useFetchStaticData({
    resource: 'dotcom-cart',
    resourcePath: 'i18n',
    file: language,
    enabled: true,
  });
  return (
    <NikeI18nProvider
      fromLocPlatform={false}
      currentLanguageTag={language}
      translations={{ [language]: translations }}
    >
      {isSuccess ? children : null}
    </NikeI18nProvider>
  );
};
NikeI18nProviderTranslations.propTypes = {
  children: PropTypes.node,
};

export default NikeI18nProviderTranslations;
